// extracted by mini-css-extract-plugin
export default {"layout":"layout--tZ9SW","cross":"cross--lwBQj"};